import Api from "../config/api";

export const findAllEncaminhamentosModelo = async (variables) => {
  const response = await Api.post("", {
    query: `query findAllEncaminhamentosModelo($ativo: Boolean, $search: String, $pageableDto: PageableDTOInput) {
      findAllEncaminhamentosModelo(ativo: $ativo, search: $search, pageableDTO: $pageableDto) {
        content {
          id
          ativo
          descricao
          nome
        }
        last
      }
    }`,variables
  });

  if (response.data.errosr) {
    throw new Error(response.data.errors[0].message);
  } else {
    return response.data.data.findAllEncaminhamentosModelo;
  }
};

export const saveEncaminhamento = async (variables) => {
  const metod = variables?.encaminhamento?.id
    ? "updateEncaminhamento"
    : "createEncaminhamento";

  const response = await Api.post("", {
    query: `mutation ($encaminhamento: EncaminhamentoEntidadeInput) {
      ${metod}(encaminhamento: $encaminhamento) {
      id
    }
  }`, variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  } else {
    return response.data.data[metod];
  }
};

export const findAllEncaminhamentosRelatorio = async (variables) => {
  const response = await Api.post("", {
    query: `query findAllEncaminhamentosModelo($ativo: Boolean, $search: String, $pageableDTO: PageableDTOInput) {
      findAllEncaminhamentosModelo(ativo: $ativo, search: $search, pageableDTO: $pageableDTO) {
        content {
          id
          nome
        }
        last
      }
    }`,variables
  });

  if (response.data.errosr) {
    throw new Error(response.data.errors[0].message);
  } else {
    return response.data.data.findAllEncaminhamentosModelo;
  }
};